module.exports = __webpack_public_path__ + "img/index-providers.ccb396c.png";